import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
type stringArray = string[];
interface GCPCreateInputRequest {
    readonly gcp_region: string;
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly log_types: string[];
    readonly name: string;
    readonly gcp_secret_path: string;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
    readonly gcp_service_account_key: unknown;
    readonly gcp_project_id: string;
    readonly page_size: number;
    readonly gcp_client_id: string;
}
/**
 * Create a new GCP input
 */
export function create(JSONbody: GCPCreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.gcp.api.GCPResource/gcp/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
/**
 * Get all available GCP regions
 */
export function getGCPRegions(): Promise<stringArray> {
    return __request__('GET', '/plugins/org.graylog.enterprise.integrations.gcp.api.GCPResource/gcp/regions', null, {}, {
        'Accept': ['application/json']
    });
}
